import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import { StatWidget } from './widgets/StatWidget';
import { fetchStats } from '../../api/statsService';
import { useEffect, useState } from 'react';
import { PopularTagsWidget } from './widgets/PopularTagsWidget';
import { TopAuthorsWidget } from './widgets/TopAuthorsWidget';

interface StatItem {
  title: string;
  value: number;
  change: string;
}

// const stats: StatItem[] = [
//   { title: 'Количество видео', value: 1245, change: '+12%' },
//   { title: 'Количество тегов', value: 89, change: '+5%' },
//   { title: 'Количество авторов', value: 342, change: '+8%' },
// ];

export const Dashboard = () => {
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadStats = async () => {
      try {
        const data = await fetchStats();
        setStats(data);
      } catch (err) {
        setError('Не удалось загрузить статистику');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadStats();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress size={60} />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  if (!stats) return null;

  return (
    <Grid container spacing={3} sx={{ padding: '24px' }}>
      <Grid
      sx={{
        width: { xs: '100%', sm: 'calc(50% - 24px)', md: 'calc(33.33% - 24px)' },
      }}
      ><StatWidget 
            title="Количество видео" 
            value={stats.total_videos} 
            change={`+${stats.last_7_days.videos}`} 
          />

      </Grid>
      <Grid
      sx={{
        width: { xs: '100%', sm: 'calc(50% - 24px)', md: 'calc(33.33% - 24px)' },
      }}
      >
        <StatWidget 
            title="Количество тегов" 
            value={stats.total_tags} 
            change={`+${stats.last_7_days.tags}`} 
          />

      </Grid>
      <Grid
      sx={{
        width: { xs: '100%', sm: 'calc(50% - 24px)', md: 'calc(33.33% - 24px)' },
      }}
      >
        <StatWidget 
            title="Количество авторов" 
            value={stats.total_authors} 
            change={`+${stats.last_7_days.authors}`} 
          />

      </Grid>
      {/* Популярные теги */}
      <Grid sx={{xs: 12, md: 6}}>
          <PopularTagsWidget tags={stats.popular_tags} />
        </Grid>

        {/* Топ авторов */}
        <Grid sx={{xs: 12, md: 6}}>
          <TopAuthorsWidget authors={stats.top_authors} />
        </Grid>
      {/* {stats.map((stat: StatItem) => (
        <Grid 
        
        sx={{
            width: { xs: '100%', sm: 'calc(50% - 24px)', md: 'calc(33.33% - 24px)' },
          }} key={stat.title}>
          <StatWidget title={stat.title} value={stat.value} change={stat.change} />
        </Grid>
      ))} */}
    </Grid>
  );
};